import { ApiBaseService } from "./api-base.service";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class PropertyService {
  constructor(private apiService: ApiBaseService) {}

  async savePropertyOwners(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/SavePropertyOwners",
      payload,
      true,
      true
    );
  }

  async getPropertyOwners(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/GetPropertyOwners",
      payload,
      true,
      true
    );
  }

  async uploadContractFileToSharepoint(payload: any, showLoader = true): Promise<any> {
    return this.apiService.httpRequestForm(
      "PropertyService/UploadContractFileToSharepoint",
      payload,
      true,
      showLoader
    );
  }

  async deletePropertyOwner(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/DeletePropertyOwner",
      payload,
      true,
      true
    );
  }

  async deleteProperty(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/DeleteProperty",
      payload,
      true,
      true
    );
  }

  async deleteRegisterFile(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/DeleteRegisterFile",
      payload,
      true,
      true
    );
  }

  async getRegisterFileFromSharepoint(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/GetRegisterFileFromSharepoint",
      payload,
      true,
      true
    );
  }

  async getContractFromSharepoint(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/GetContractFromSharepoint",
      payload,
      true,
      true
    );
  }

  async deletePropertyContract(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/DeleteContract",
      payload,
      true,
      true
    );
  }

  async getDocument(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/GetDocument",
      payload,
      true,
      true
    );
  }

  async setPropertyTaskStatus(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/SetPropertyTaskStatus",
      payload,
      true,
      true
    );
  }

  async getPropertyTaskStatus(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/GetPropertyTaskStatus",
      payload,
      true,
      true
    );
  }

  async removeContractFromPropertyOwner(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/RemoveContractFromPropertyOwner",
      payload,
      true,
      true
    );
  }

  async addContractToPropertyOwner(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "PropertyService/AddContractToPropertyOwner",
      payload,
      true,
      true
    );
  }
}
